import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment-timezone';
import { Box } from '@famly/mf_layout_box';
import { compose } from '@famly/vet_ts-utils_typescript';
import { connectState } from 'signin-app/helpers/connect-state';
import lifecycle from 'web-app/react/components/higher-order/lifecycle';
import { getFormattedTime } from 'signin-app/helpers/time';
import { ListTimes } from 'signin-app/components/list-times/list-times';
import * as GroupsSelectors from 'signin-app/groups/selectors';
import * as Selectors from './selectors';
import { selectLeaveHours, selectLeaveMinutes } from './actions';
const LeaveTime = (props) => {
    const { selectedHours, selectedMinutes, checkoutTimeOptions } = props;
    return (_jsx(Box, { children: _jsx(ListTimes, { times: checkoutTimeOptions, selectedHours: selectedHours, selectedMinutes: selectedMinutes, displayMinutes: getFormattedTime, onHoursChange: selectLeaveHours.dispatch, onMinutesChange: selectLeaveMinutes.dispatch, e2eHourUnit: "employee-leave-hour-unit", isEmployee: true }) }));
};
const mapStateToProps = (state) => ({
    selectedHours: Selectors.selectedHours(state),
    selectedMinutes: Selectors.selectedMinutes(state),
    timezone: GroupsSelectors.timezone(state),
    checkoutTimeOptions: Selectors.checkoutTimeOptions(state),
});
const initializeFromProps = (props) => {
    const { selectedLeaveTime, checkedIn, timezone } = props;
    if (selectedLeaveTime && checkedIn && timezone) {
        const leaveTime = moment(selectedLeaveTime).tz(timezone);
        selectLeaveHours.dispatch(leaveTime.hour());
        selectLeaveMinutes.dispatch(leaveTime.minute());
    }
};
export default compose(connectState(mapStateToProps))
    .with(lifecycle(initializeFromProps))
    .apply(LeaveTime);
